<button [class]="className" (click)="select()" [disabled]="disabled ? 'disabled' : null">
  {{ title }}
</button>
